import styled from 'styled-components';

import { theme } from '../../../../global';

export const Form = styled.form`
  padding-top: 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AccordionElementsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Line = styled.div`
  flex: 1;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.line};
`;

export const ButtonsContainer = styled.div`
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  button {
    flex: 1;
    height: 56px;
  }
`;
